// extracted by mini-css-extract-plugin
export var emailBlockLink = "_ip-0";